import React from "react";
import ManageUserSection from "../components/Users/Add/ManageUserSection";

const ManageUser = () => {
  return <ManageUserSection />;
};

export default ManageUser;
